import {
  type Cart as CartData,
  CartType,
} from "@cappelendamm/e-commerce-services";
export const INITIAL_CART: CartData = {
  id: "initial",
  items: [],
  state: "cart",
  total: {
    gross: 0,
    currency: "NOK",
    net: 0,
    taxAmount: 0,
  },
  updatedAt: "initial",
  cartType: CartType.SHOP,
  freeShippingThreshold: `${Number.MAX_SAFE_INTEGER}`,
} as const;

export const UNINITIALIZED_CART: CartData = {
  ...INITIAL_CART,
  id: "not-loaded",
} as const;
